import * as React from 'react'
import PropTypes from 'prop-types'

import * as Common from '@rushplay/common'

import { H1 } from '../components/common/headings'
import { HtmlContent } from '../components/common/html-content'

export function StaticPage(props) {
  const [content, setContent] = React.useState(null)

  const contentFromRef = React.useCallback(node => {
    if (node) {
      var blob = new Blob(['\ufeff', node.textContent], {
        type: 'text/plain',
      })
      setContent(URL.createObjectURL(blob))
    }
  }, [])

  return (
    <Common.Box dispaly="flex" maxWidth="800px" margin="auto">
      <Common.Space paddingBottom={4}>
        <H1 align="center" color="gray">
          {props.title}
        </H1>
      </Common.Space>
      <Common.Box ref={contentFromRef}>
        <HtmlContent html={{ __html: props.content }} />
      </Common.Box>
      <Common.Box py="4" textAlign="center">
        <Common.Text
          as="a"
          download="simple-casino-terms-and-conditions"
          href={content}
          color="simpleorange"
          textDecoration="underline"
          fontSize="16px"
        >
          {props.translate('terms-and-conditions.download')}
        </Common.Text>
      </Common.Box>
    </Common.Box>
  )
}

StaticPage.propTypes = {
  content: PropTypes.string,
  title: PropTypes.string,
  translate: PropTypes.func,
}
